<template>
  <section>
    <Schedule />
  </section>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "Creative"
    };
  },

  components: {
    Schedule: () => import("@/components/Schedule.vue")
  }
};
</script>
